import React, { FC } from 'react';

import { Semibold } from '@zazume/zzm-base';

import { FieldValue } from '#/components/pages/detail';
import { FieldValueBase, FieldValueBaseProps } from '#/components/pages/detail/FieldsSection/atoms/FieldValueBase';

interface MultiLinesFielValueProps extends FieldValueBaseProps {}

type Component = FC<MultiLinesFielValueProps> & {
  Skeleton: typeof Skeleton;
};

export const MultiLinesFielValue: Component = ({ title, isDefaultHidden, tooltip, children }) => {
  return (
    <FieldValueBase title={title} isDefaultHidden={isDefaultHidden} tooltip={tooltip}>
      {children}
    </FieldValueBase>
  );
};

const Skeleton: FC<{ title: string }> = ({ title, children }) => {
  return (
    <FieldValue
      title={title}
      value={
        <>
          {React.Children.toArray(children).map(children => (
            <Semibold.Skeleton width={title.length} />
          ))}
        </>
      }
    />
  );
};

MultiLinesFielValue.Skeleton = Skeleton;
